"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
if (!('localStorage' in globalThis)) {
    globalThis.localStorage = null;
}
const sdk_constants_1 = require("../constants/sdk.constants");
const getWithExpiry = (key) => {
    if (!globalThis.localStorage)
        return null;
    const itemStr = globalThis.localStorage.getItem(key);
    if (!itemStr) {
        return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime > item.expiry) {
        globalThis.localStorage.removeItem(key);
        return null;
    }
    return item.value;
};
const setWithExpiry = (key, value) => {
    if (!globalThis.localStorage)
        return null;
    const now = new Date();
    const item = {
        value: value,
        expiry: now.getTime() + sdk_constants_1.LOCAL_STORAGE_TTL,
    };
    globalThis.localStorage.setItem(key, JSON.stringify(item));
};
const removeMultiple = (keys) => {
    if (!globalThis.localStorage)
        return null;
    keys.forEach((key) => {
        globalThis.localStorage.removeItem(key);
    });
};
const exportFunctions = {
    getWithExpiry,
    setWithExpiry,
    removeMultiple,
};
exports.default = exportFunctions;
//# sourceMappingURL=local-storage.helper.js.map